import { render, staticRenderFns } from "./add-physicalmodel.vue?vue&type=template&id=2c24f0e9"
import script from "./add-physicalmodel.vue?vue&type=script&lang=js"
export * from "./add-physicalmodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c24f0e9')) {
      api.createRecord('2c24f0e9', component.options)
    } else {
      api.reload('2c24f0e9', component.options)
    }
    module.hot.accept("./add-physicalmodel.vue?vue&type=template&id=2c24f0e9", function () {
      api.rerender('2c24f0e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/physicalmodel/add-physicalmodel.vue"
export default component.exports